module.exports = function(angularModule) {
  angularModule.controller('listingStatsSummaryController', function($scope, $state, $stateParams, $http, $log, timePeriodService) {

    $scope.loading = true;
    $scope.offset = Number($stateParams.count) || 0;
    $scope.periodType = $stateParams.periodType || 'day';
    $scope.onUpdateTimePeriod = function(periodType, offset) {
      $state.go('.', { periodType, offset });
    };

    var dateRange = timePeriodService.periodToDateRange({ periodType: $scope.periodType, offset: $scope.offset});
    $http.get('/healthmeter/listingstats/timerange', { params: dateRange }).then((resp) => {

      $scope.loading = false;
      $scope.data = resp.data;
    })
  });
};
/**
 * possible TODOs:
 *      1) Need some way to bubble useful information to the top. sort by stat fields?.
 *      2) either add hourly provider detail (like healthmeter) or remove that data from the API response if it doesn't seem useful
 *      3) Some kind of central healthmeter page to link to listings stats and provider statuses
 */
